<ion-app>
  <div
    class="app-background"
    [ngClass]="{
      'app-background__image': hasAnyBackgroundImg,
    }"
    [style.backgroundImage]="backgroundImage"
  >
    <div class="app-container">
      @if (scrollState.isAppReady()) {
        <app-header
          (closeClicked)="onHeaderCloseClicked()"
          (tabSelected)="onHeaderTabSelected($event)"
        />
      }

      <app-game-host
        [controlMode]="'game-only'"
        [class.game-hidden]="!orchestration.isActive() || !scrollState.isGameRoute()"
        [class.game-concealed]="concealGameUnderTierFirst()"
      />

      <ion-content
        [class.game-route]="scrollState.isGameRoute()"
        [class.leaderboard-route]="scrollState.isLeaderboardRoute()"
        [class.app-loading]="!scrollState.isAppReady()"
      >
        <div
          class="tab-content-wrapper"
          [class.game-route]="scrollState.isGameRoute()"
          [class.leaderboard-route]="scrollState.isLeaderboardRoute()"
          [class.app-loading]="!scrollState.isAppReady()"
        >
          <ion-router-outlet id="main-content" [animated]="false" [swipeGesture]="false" />
        </div>
      </ion-content>
    </div>
  </div>
</ion-app>
